"use client";
import { FC } from "react";
import { useSelector } from "react-redux";

import Skeleton from "react-loading-skeleton";
import { useScreen } from "../context/ScreenContext";
import { useTranslations } from "next-intl";
import { I18N_NAMESPACE } from "@/config/i18n";
import CasinoGroupWidgetSwiperWithTitle from "./CasinoPage/CasinoGroupWidgetSwiperWithTitle";
import { usePathname } from "../navigation";
import classNames from "classnames";
import { ICasinoGroupViewModel } from "../fe-core-omega/meta/interfaces/casino";
import { gameCardTooltipGameSelector, groupsSelector } from "../fe-core-omega/_redux/selectors/casinoSelectors";

interface Props {
  title: string;
  className?: string;
  isSearchSlider?: boolean;
  hidePlayButton?: boolean;
}
const GamesGroup: FC<Props> = ({
  title = "",
  className = "",
  isSearchSlider = false,
  hidePlayButton = false,
}) => {
  const { isMobile } = useScreen();
  const t = useTranslations(I18N_NAMESPACE.CATEGORIES);
  const pathname = usePathname();
  const activeTooltipGame = useSelector(gameCardTooltipGameSelector);
  // @todo, add related selector
  const groups: ICasinoGroupViewModel[] | null = useSelector(groupsSelector);

  const getPopularSkeleton = () => {
    const gameCount = isMobile ? 2 : 6;
    return (
      <div className={classNames("container relative", className)}>
        <div className="">
          <div className="flex items-center gap-2 mb-4">
            {/* <Icon name="star" size="small" color="grey-1" /> */}

            <div className="text-lg font-bold">{title}</div>
          </div>
          <Skeleton
            containerClassName={`skeleton-game-group grid grid-cols-2 md:grid-cols-${gameCount} gap-4`}
            count={gameCount}
            inline={true}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={classNames(``, className)}>
      {groups && (
        <CasinoGroupWidgetSwiperWithTitle
          group={{ ...groups[1], name: title }}
          isLiveGame={false}
          key={`group-${1}`}
          hidePlayButton={
            hidePlayButton || (!["/"].includes(pathname) && !isMobile)
          }
          groupId={groups?.[1]?.slug}
          className="!my-0"
        />
      )}
      {!groups && getPopularSkeleton()}
    </div>
  );
};
export default GamesGroup;
